import {msg, str} from '@lit/localize';
import {LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {
	SUB_ACTIVE, SUB_ACTIVE_PENDING,
	SUB_NONE,
	SUB_PAST_DUE,
	SUB_PAUSED, SUB_SCHEDULED_TO_CANCEL, SUB_TRIAL_EXPIRED,
	SUB_TRIALING
} from '../../services/subscription/subscriptionStatus';
import {
	selectCancelDaysLeft,
	selectCurrentSubscription,
	selectLanguage, selectScheduledToCancelAt,
	selectSubscribedPlan,
	selectSubscriptionStatus,
	selectTrialDaysLeft
} from '../../selectors';
import store from '../../store';

@customElement('arc-subscription-status')
export class SubscriptionStatus extends connect(store)(LitElement) {

	static properties = {
		type: {type: String},
		status: {type: String},
		subscribedPlan: {type: Object},
		subscription: {type: Object},
		trialDaysLeft: {type: Number},
		cancellationDaysLeft: {type: Number}
	};

	constructor() {
		super();
		this.subscribedPlan = null;
		this.subscription = null;
		this.status = '';
		this.trialDaysLeft = 0;
		this.cancellationDaysLeft = 0;
		this.type = 'default';
	}

	stateChanged(state) {
		this.subscribedPlan = selectSubscribedPlan(state);
		this.subscription = selectCurrentSubscription(state);
		this.status = selectSubscriptionStatus(state);
		this.trialDaysLeft = selectTrialDaysLeft(state);
		this.cancellationDaysLeft = selectCancelDaysLeft(state);
	}

	render() {
		const isBanner = this.type === 'banner';
		const isChoosePlan = this.type === 'choosePlan';
		let statusMessage = '';
		if (this.status === SUB_TRIALING) {
			const trialDaysLeft = this.trialDaysLeft;
			statusMessage = msg(str`${trialDaysLeft} left on trial subscription`, {id: 'subscription_status_trialing'});
			if (isBanner) {
				statusMessage = msg(str`${trialDaysLeft} left on trial subscription`, {id: 'subscription_status_trialing_banner'});
			} else if (isChoosePlan) {
				statusMessage = msg(str`${trialDaysLeft} left on trial subscription`, {id: 'subscription_status_trialing_choosePlan'});
			}
		} else if (this.status === SUB_TRIAL_EXPIRED) {
			statusMessage = msg('subscription_status_trial_expired');
			if (isBanner) {
				statusMessage = msg('subscription_status_trial_expired_banner');
			} else if (isChoosePlan) {
				statusMessage = msg('subscription_status_trial_expired_choosePlan');
			}
		} else if (this.status === SUB_ACTIVE || this.status === SUB_ACTIVE_PENDING) {
			statusMessage = msg('subscription_status_active');
			if (isChoosePlan) {
				statusMessage = msg('subscription_status_active_choosePlan');
			}
		} else if (this.status === SUB_SCHEDULED_TO_CANCEL) {
			const cancellationDaysLeft = this.cancellationDaysLeft;
			statusMessage = msg(str`${cancellationDaysLeft}`, {id: 'subscription_status_scheduled_to_cancel'});
			if (isChoosePlan) {
				statusMessage = msg(str`${cancellationDaysLeft}`, {id: 'subscription_status_scheduled_to_cancel_choosePlan'});
			}
		} else if (this.status === SUB_PAUSED) {
			statusMessage = msg('subscription_status_paused');
		} else if (this.status === SUB_PAST_DUE) {
			statusMessage = msg('subscription_status_past_due');
		} else {
			statusMessage = msg('subscription_status_none');
		}

		return statusMessage;
	}
}
